import React, {useState} from "react";
import { Table, Container, Pagination } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faEye } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { BtnBorrarDinamico, BtnBoostrapDinamico } from "../Botones";
import { ModalDinamico } from "../Modals";
import { FormEditPlanta } from "../Forms_Edit";
import { useDispatch } from "react-redux";
import { DeletePlanta } from "../../Api/Plantas.Api";

export const TablaPlantas = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

    const PAGE_SIZE = 10;
    const [currentPage, setCurrentPage] = useState(1);

    const indexOfLastItem = currentPage * PAGE_SIZE;
    const indexOfFirstItem = indexOfLastItem - PAGE_SIZE;
    const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <Container
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "800px",
        overflowY: "auto",
        marginTop: "20px",
      }}
    >
      <Table>
        <thead
          style={{
            backgroundColor: "#fed8",
            fontStyle: "italic",
            fontWeight: "bold",
            fontSize: ".8rem",
          }}
        >
          <tr>
            <td>Planta</td>
            <td>Detalle</td>
            <td>Editar</td>
            <td>Borrar</td>
          </tr>
        </thead>
        <tbody>
          {data.map((e) => (
            <tr key={e.pl_iden}>
              <td>{e.pl_desc}</td>
              <td>
                <BtnBoostrapDinamico
                  size={"sm"}
                  name={<FontAwesomeIcon icon={faEye} />}
                  click={() =>
                    navigate(`/Empresa/${e.em_iden}/Planta/${e.pl_iden}/Zonas`)
                  }
                />
              </td>
              <td>
                <ModalDinamico
                  size={"sm"}
                  variant={"outline-success"}
                  Body={<FormEditPlanta id={e.pl_iden} />}
                  Titulo="Editar Planta"
                  nameBoton={<FontAwesomeIcon size="xs" icon={faPenToSquare} />}
                />
              </td>
              <td>
                <BtnBorrarDinamico
                  action={() => dispatch(DeletePlanta(e.pl_iden))}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination style={{ display: "flex", flexWrap: "wrap" }}>
        {Array.from({ length: Math.ceil(data.length / PAGE_SIZE) }).map(
          (item, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          )
        )}
      </Pagination>
    </Container>
  );
};
